import React, { useMemo } from 'react';
import icon1 from '../../../assets/icon-mdi-lead.svg';
import icon2 from '../../../assets/icon-list-outline.svg';
import icon3 from '../../../assets/icon-add.svg';
import icon4 from '../../../assets/icon-email-outline.svg';
import icon5 from '../../../assets/icon-email-open-outline.svg';
import icon6 from '../../../assets/icon-click.svg';
import icon7 from '../../../assets/icon-follow-up.svg';
import icon8 from '../../../assets/icon-reply.svg';
import icon9 from '../../../assets/icon-call-outline.svg';
import icon10 from '../../../assets/icon-notes-outline.svg';
import icon11 from '../../../assets/icon-status-outline.svg';
import icon12 from '../../../assets/icon-positive-reply.svg';
import icon13 from '../../../assets/icon-not-interested.svg';
import icon14 from '../../../assets/icon-opportunity.svg';
import icon15 from '../../../assets/icon-pause-campaign.svg';
import icon16 from '../../../assets/icon-resume-campaign.svg';
import icon17 from '../../../assets/icon-import-job.svg';
import icon18 from '../../../assets/icon-bounce-email.svg';
import icon19 from '../../../assets/icon-unsubscribe.svg';

import { ActivityTabStyle } from './LeadPreviewSection.styles';
import { formatDate, formatTime } from '../../../helpers/common';

const activityIconMap = {
  LEAD_CREATED: icon1,
  ADDED_TO_LIST: icon2,
  ADDED_TO_CAMPAIGN: icon3,
  REMOVED_FROM_LIST: icon2,
  REMOVED_FROM_CAMPAIGN: icon3,
  EMAIL_SENT: icon4,
  EMAIL_OPENED: icon5,
  EMAIL_CLICKED: icon6,
  FOLLOW_UP: icon7,
  EMAIL_REPLIED: icon8,
  DEMO_CALL: icon9,
  NOTES_ATTACHED: icon10,
  STATUS_UPDATED: icon11,
  POSITIVE_REPLY: icon12,
  NOT_INTERESTED: icon13,
  OPPORTUNITY: icon14,
  CAMPAIGN_PAUSED: icon15,
  CAMPAIGN_RESUMED: icon16,
  ADDED_TO_IMPORT_JOB: icon17,
  REMOVED_FROM_IMPORT_JOB: icon17,
  EMAIL_BOUNCED: icon18,
  UNSUBSCRIBE: icon19
};

const ActivityTab = ({ activityLogs = [], loading = false }) => {
  if (loading) {
    return (
      <ActivityTabStyle>
        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>Loading activity logs...</div>
      </ActivityTabStyle>
    );
  }

  if (activityLogs.length === 0) {
    return (
      <ActivityTabStyle>
        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>No activity logs found</div>
      </ActivityTabStyle>
    );
  }

  return (
    <>
      <ActivityTabStyle>
        {activityLogs.map((item, index) => (
          <div className="text-holder" key={index}>
            <div className="wrap">
              <div className="img-box">
                <img src={activityIconMap[item.activityType] || icon1} alt="activity icon" />
              </div>
              <div className="text-box">
                <strong className="title">{item.activityTitle || 'Activity'}</strong>
                <span className="text">{item.activityDescription || 'No description'}</span>
              </div>
            </div>
            <div className="time-col">
              <span className="date">{formatDate(item.updated_at)}</span>
              <span className="time">{formatTime(item.updated_at)}</span>
            </div>
          </div>
        ))}
      </ActivityTabStyle>
    </>
  );
};

export default ActivityTab;
